/* eslint-disable max-lines */
import okiApplication from '../../api/oki-api';
export const OKI_TECHNICAL_FAILURE = 'OKI_TECHNICAL_FAILURE';
import { ROUTE_NAMES } from './constants/oki-constants';
const OKI_SET_SOKI = 'OKI_SET_SOKI';
const OKI_SET_COUNTIES = 'OKI_SET_COUNTIES';
const OKI_SET_DISTRICTS = 'OKI_SET_DISTRICTS';
const OKI_SET_MOBILE_PROVIDERS = 'OKI_SET_MOBILE_PROVIDERS';
const OKI_SET_NOTIFICATION_METHODS = 'OKI_SET_NOTIFICATION_METHODS';
const OKI_SET_USAGE_SCOPES = 'OKI_SET_USAGE_SCOPES';
const OKI_SET_CURRENT_PAGE = 'OKI_SET_CURRENT_PAGE';
const OKI_ADD_VISITED_PAGES = 'OKI_ADD_VISITED_PAGES';
const OKI_SET_SW_IMAGE_PATH = 'OKI_SET_SW_IMAGE_PATH';
const OKI_SET_CARD_DATA = 'OKI_SET_CARD_DATA';
export const OKI_SET_CAPTCHA_DATA = 'OKI_SET_CAPTCHA_DATA';
export const OKI_SET_CAPTCHA_ERROR = 'OKI_SET_CAPTCHA_ERROR';
const OKI_SET_SESSION_ID = 'OKI_SET_SESSION_ID';
const OKI_ADD_VALID_PAGES = 'OKI_ADD_VALID_PAGES';
const OKI_SET_VALID_PAGES = 'OKI_SET_VALID_PAGES';
const OKI_SAVE_ALL_PAGES_DATA = 'OKI_SAVE_ALL_PAGES_DATA';
const OKI_SET_FINISHED = 'OKI_SET_FINISHED';
const OKI_SET_VISITED_PAGES = 'OKI_SET_VISITED_PAGES';
const OKI_SET_IS_DEVIZA_CARD = 'OKI_SET_IS_DEVIZA_CARD';
const OKI_SET_CURRENCY = 'OKI_SET_CURRENCY';
const OKI_CLEAR_FINANCIAL_CLAIM_CODE_FIELDS = 'OKI_CLEAR_FINANCIAL_CLAIM_CODE_FIELDS';
export const OKI_SET_ERROR_CODES = 'OKI_SET_ERROR_CODES';

const HUF = 'huf';
const okiState = {
	soki: false,
	sessionId: null,
	currentPage: null,
	visitedPages: [],
	validPages: [],
	loading: false,
	technicalError: false,
	counties: [],
	districts: [],
	mobileProviders: [],
	notificationMethods: [],
	usageScopes: [],
	schools: [],
	cardData: null,
	captcha: null,
	captchaError: null,
	allPagesData: null,
	finished: false,
	swImgPath: null,
	errorCodes: [],
	isDevizaCard: false,
	currency: ''
};
const okiGetters = {
	visitedSummary: (state) => {
		return state.visitedPages.indexOf(ROUTE_NAMES.OSSZEGZES) != -1;
	},
	isOnLastPage: (state) => {
		return state.currentPage == ROUTE_NAMES.OSSZEGZES;
	}
};

const okiActions = {
	init({ commit }, cardId) {
		return new Promise((resolve, reject) => {
			okiApplication.init(cardId).then(
				(response) => {
					commit(OKI_SET_COUNTIES, response.data.dropdowns.counties);
					commit(OKI_SET_DISTRICTS, response.data.dropdowns.districts);
					commit(OKI_SET_MOBILE_PROVIDERS, response.data.dropdowns.mobileProviders);
					commit(OKI_SET_NOTIFICATION_METHODS, response.data.dropdowns.notificationMethods);
					commit(OKI_SET_USAGE_SCOPES, response.data.dropdowns.usageScopes);
					commit(OKI_SET_CARD_DATA, response.data.card);
					commit(OKI_SET_SOKI, response.data.okiSoki == 'SOKI');
					commit(OKI_SET_CAPTCHA_DATA, response.data.captcha);
					commit(OKI_SET_SESSION_ID, response.data.sessionId);
					if (response.data.card && response.data.card.currency) {
						commit(OKI_SET_IS_DEVIZA_CARD, response.data.card.currency.toLowerCase() != HUF);
					}
					if (response.data.card && response.data.card.currency) {
						commit(OKI_SET_CURRENCY, response.data.card.currency);
					}

					resolve(response);
				},
				(error) => {
					commit(OKI_TECHNICAL_FAILURE);
					reject(error);
				}
			);
		});
	},
	setCurrentPage({ commit }, currentPage) {
		commit(OKI_SET_CURRENT_PAGE, currentPage);
	},
	setSwImagePath({ commit }, swImgPath) {
		commit(OKI_SET_SW_IMAGE_PATH, swImgPath);
	},
	addVisitedPages({ commit, state }, page) {
		if (state.visitedPages.indexOf(page) == -1) {
			commit(OKI_ADD_VISITED_PAGES, page);
		}
	},
	addValidPages({ commit, state }, page) {
		if (state.validPages.indexOf(page) == -1) {
			commit(OKI_ADD_VALID_PAGES, page);
		}
	},
	removeValidPages({ commit, state }, page) {
		let index = state.validPages.indexOf(page);
		if (state.validPages.indexOf(page) != -1) {
			let pages = state.validPages.slice();
			pages.splice(index, 1);
			commit(OKI_SET_VALID_PAGES, pages);
		}
	},
	removeVisitedPages({ commit, state }, page) {
		let index = state.visitedPages.indexOf(page);
		if (state.visitedPages.indexOf(page) != -1) {
			let pages = state.visitedPages.slice(); // copy the array
			pages.splice(index, 1);
			commit(OKI_SET_VISITED_PAGES, pages);
		}
	},
	clearFinancialInputFields({ commit }) {
		commit(OKI_CLEAR_FINANCIAL_CLAIM_CODE_FIELDS);
	},
	postAllForms({ commit, state }) {
		okiApplication.finishClaim(state.sessionId).then(
			() => {
				commit(OKI_SET_FINISHED, true);
			},
			() => {
				commit(OKI_TECHNICAL_FAILURE);
			}
		);
	},
	postTaData(context, data) {
		if (data.vhk) {
			okiApplication.postTaVhkData(data.taData);
		} else {
			okiApplication.postTaData(data.taData);
		}
	},
	collectErrorCodes({ commit }, errorObject) {
		let errorCodes = [];
		for (let elem in errorObject) {
			if (errorObject.hasOwnProperty(elem) && errorObject[elem] && typeof errorObject[elem] === 'object' && errorObject[elem].length) {
				errorCodes = [...errorCodes, ...errorObject[elem]];
			}
		}
		commit(OKI_SET_ERROR_CODES, errorCodes);
	}
};
const okiMutations = {
	[OKI_TECHNICAL_FAILURE](state) {
		state.technicalError = true;
		state.loading = false;
	},
	[OKI_SET_SOKI](state, soki) {
		state.soki = soki;
	},
	[OKI_SET_COUNTIES](state, counties) {
		state.counties = counties;
	},
	[OKI_SET_DISTRICTS](state, districts) {
		state.districts = districts;
	},
	[OKI_SET_MOBILE_PROVIDERS](state, mobileProviders) {
		state.mobileProviders = mobileProviders;
	},
	[OKI_SET_NOTIFICATION_METHODS](state, notificationMethods) {
		state.notificationMethods = notificationMethods;
	},
	[OKI_SET_USAGE_SCOPES](state, usageScopes) {
		state.usageScopes = usageScopes;
	},
	[OKI_SET_CURRENT_PAGE](state, currentPage) {
		state.currentPage = currentPage;
	},
	[OKI_ADD_VISITED_PAGES](state, page) {
		state.visitedPages.push(page);
	},
	[OKI_SET_CARD_DATA](state, cardData) {
		state.cardData = cardData;
	},
	[OKI_SET_CAPTCHA_DATA](state, captcha) {
		state.captcha = captcha;
	},
	[OKI_SET_CAPTCHA_ERROR](state, error) {
		state.captchaError = error;
	},
	[OKI_SET_SESSION_ID](state, sessionId) {
		state.sessionId = sessionId;
	},
	[OKI_ADD_VALID_PAGES](state, page) {
		state.validPages.push(page);
	},
	[OKI_SAVE_ALL_PAGES_DATA](state, data) {
		state.allPagesData = data;
	},
	[OKI_SET_FINISHED](state, data) {
		state.finished = data;
	},
	[OKI_SET_SW_IMAGE_PATH](state, data) {
		state.swImgPath = data;
	},
	[OKI_SET_VISITED_PAGES](state, pages) {
		state.visitedPages = pages;
	},
	[OKI_SET_VALID_PAGES](state, pages) {
		state.validPages = pages;
	},
	[OKI_CLEAR_FINANCIAL_CLAIM_CODE_FIELDS](state) {
		state.financial.financialData.atmLimit = '';
		state.financial.financialData.purchaseLimit = '';
		state.financial.financialData.purchaseLimitEqualsBalance = false;
		state.financial.financialData.internetLimit = '';
		state.financial.financialData.internetLimitEqualsBalance = false;
		state.financial.financialData.mobilePhoneNumberForConfirmation = '';
		state.financial.financialData.summarizedDailyLimit = '';
		state.financial.financialData.usageScope = null;
	},
	[OKI_SET_ERROR_CODES](state, errorCodes) {
		state.errorCodes = errorCodes;
	},
	[OKI_SET_IS_DEVIZA_CARD](state, isDevizaCard) {
		state.isDevizaCard = isDevizaCard;
	},
	[OKI_SET_CURRENCY](state, currency) {
		state.currency = currency;
	}
};
export default {
	state: okiState,
	getters: okiGetters,
	mutations: okiMutations,
	actions: okiActions
};

/* eslint-enable max-lines */
